import React from 'react';
import T from 'prop-types';
import classNames from 'classnames';
import { isMediumViewport } from '../Hooks/useMedia';

const ListSelect = (props) => {
  if (typeof window === 'undefined') return null;

  const getUrl = (event, url) => {
    event.preventDefault();
    const activeAnchor = window.document.querySelector('.current');
    const currentLevel = activeAnchor
      ? activeAnchor.getAttribute('href')
      : null;
    if (currentLevel) {
      window.open(url + currentLevel, '_self');
    } else {
      window.open(url, '_self');
    }
  };

  return (
    <div className="c-listselect">
      {props.Label && (
        <span className="c-listselect__label" data-cy="c-listselect-label">
          {props.Label}
        </span>
      )}
      {props.Items && (
        <ul className="c-listselect__list">
          {props.Items.map((item, index) => {
            const linkClasses = classNames({
              'c-listselect__list__item__link': true,
              'c-listselect__list__item__link--active': item.Selected,
              'c-listselect__list__item__link--inactive': !item.Url,
            });

            return (
              <li
                className="c-listselect__list__item"
                data-cy="c-listselect-item"
                key={index}
              >
                {item.Url ? (
                  <a
                    onClick={(e) => getUrl(e, item.Url)}
                    className={linkClasses}
                  >
                    {item.Title}
                  </a>
                ) : (
                  <>
                    <button
                      className={linkClasses}
                      disabled={true}
                      tabIndex="0"
                    >
                      {item.Title}
                      {item.Tooltip && !isMediumViewport() && (
                        <span className="show-for-sr">{item.Tooltip}</span>
                      )}
                    </button>
                    {item.Tooltip && !isMediumViewport() && (
                      <div className="c-listselect__list__item__link__tooltip">
                        {item.Tooltip}
                      </div>
                    )}
                    {item.Tooltip && isMediumViewport() && (
                      <div className="c-listselect__list__item__link__inactive-label">
                        {item.Tooltip}
                      </div>
                    )}
                  </>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

ListSelect.propTypes = {
  Label: T.string,
  Items: T.arrayOf(
    T.shape({
      Title: T.string,
      Selected: T.bool,
      Url: T.string,
      Tooltip: T.string,
    })
  ),
};

export default ListSelect;
